/**
 * /frontend/src/features/analytics/components/bottleneck/ImbalanceAlertCards.js
 */

import React, { useMemo } from 'react';
import './ImbalanceAlertCards.css';

const toCards = (data) => (data || []).filter((row) => Boolean(row?.imbalanceFlag));

/**
 * Alert cards for imbalanced sections.
 * @param {{data:Array<any>}} props
 * @returns {JSX.Element}
 */
const ImbalanceAlertCards = ({ data }) => {
  const cards = useMemo(() => toCards(data), [data]);
  if (cards.length === 0) return null;

  return (
    <div className="analytics-imbalance">
      <h4>Imbalance Alerts</h4>
      <div className="analytics-imbalance-grid">
        {cards.map((row) => (
          <div key={row.sectionName} className="analytics-imbalance-card">
            <div className="analytics-imbalance-title">{row.sectionName}</div>
            <div className="analytics-imbalance-subtitle">
              Wait is {Number(row.deviationFromStoreAveragePercent || 0).toFixed(0)}% above store average
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImbalanceAlertCards;

